import { type ReactNode } from "react";
import { cn } from "@/lib/utils";

type IconHeadingProps = {
  as?: "h1" | "h2" | "h3" | "h4";
  icon: ReactNode;
  children: ReactNode;
  className?: string;
};

export const IconHeading = ({
  as: Heading = "h3",
  icon,
  children,
  className,
}: IconHeadingProps) => (
  <Heading
    className={cn("flex min-w-0 items-start gap-3 text-left", className)}
  >
    <span
      aria-hidden="true"
      className="mt-[0.15em] inline-flex shrink-0 text-primary [&_svg]:!m-0 [&_svg]:!h-[1.1em] [&_svg]:!w-[1.1em]"
    >
      {icon}
    </span>
    <span className="min-w-0">{children}</span>
  </Heading>
);
